import moment from 'moment'
import { PI_TAGS } from './constants/piTags'
import {
    TOWER_DEPROP_1,
    TOWER_DEPROP_2,
    TOWER_DEPROP_3,
    TOWER_DEPROP_4,
    TOWER_DEBUT_1,
    TOWER_DEBUT_3,
    TOWER_DEBUT_4,
    TOWER_SPLITTER_1,
    TOWER_SPLITTER_3,
    TOWER_SPLITTER_4,
    TOWER_SPLITTER_6,
    TOWER_UPGRADER,
} from './constants/towerNames'
import RestEndPoint from '../../common/RestEndPoint'

export const makePayload = (daysInMonth, month, selectedYear) => {
    return {
        Dates: daysInMonth,
        PiTags: PI_TAGS,
        Month: month,
        Year: selectedYear
    }
}

export const getDaysInMonth = (year, month) => {
    const daysInMonth = []
    const date = new Date(year, month - 1, 1)

    while (date.getMonth() == month - 1) {
        daysInMonth.push(moment(new Date(date)).format('yyyy-MM-DD'))
        date.setDate(date.getDate() + 1)
    }

    return daysInMonth;
}

export const getDaysMonthYear = (date) => {
    const selectedMonth = new Date(date).getMonth() + 1 // (January gives 0)
    const selectedYear = new Date(date).getFullYear()
    const daysInMonth = getDaysInMonth(selectedYear, selectedMonth)

    return {
        selectedMonth,
        daysInMonth,
        selectedYear
    }
}

export const getCorrespondingTowerName = (field) => {
    if (field.includes('DEPROP_1'))
        return TOWER_DEPROP_1
    if (field.includes('DEPROP_2'))
        return TOWER_DEPROP_2
    if (field.includes('DEPROP_3'))
        return TOWER_DEPROP_3
    if (field.includes('DEPROP_4'))
        return TOWER_DEPROP_4
    if (field.includes('DEBUT_1'))
        return TOWER_DEBUT_1
    if (field.includes('DEBUT_3'))
        return TOWER_DEBUT_3
    if (field.includes('DEBUT_4'))
        return TOWER_DEBUT_4
    if (field.includes('SPLITTER_1'))
        return TOWER_SPLITTER_1
    if (field.includes('SPLITTER_3'))
        return TOWER_SPLITTER_3
    if (field.includes('SPLITTER_4'))
        return TOWER_SPLITTER_4
    if (field.includes('SPLITTER_6'))
        return TOWER_SPLITTER_6
    if (field.includes('UPGRADER'))
        return TOWER_UPGRADER
    return null
}

export const getCoreValues = (towerName, date, screenRowDataBackup) => {
    const matchedRow = screenRowDataBackup.find(item => {
        return item.Date === date && item.Tower === towerName
    })
    return {
        ID: matchedRow.ID,
        UpdatedOn: matchedRow.UpdatedOn,
        UpdatedBy: matchedRow.UpdatedBy
    }
}

export const makesRowToBeUpated = (updatedRows) => {
    const currentUser = RestEndPoint.getCurrentUserName();
    const currentTime = moment(new Date())
    const data = updatedRows.map(item => {
        delete item.Tower
        delete item.Date
        delete item.GridTowerName
        return {
            ...item,
            UpdatedOn: currentTime,
            UpdatedBy: currentUser
        }
    })
    return data
}

const getTowerDetails = (tower, data) => {
    const { HoursOffline, AdjustedHoursOffline, Reason } = data
    switch (tower) {
        case TOWER_DEPROP_1:
            return {
                TOWER_DEPROP_1,
                TOWER_DEPROP_1_HoursOffline: HoursOffline,
                TOWER_DEPROP_1_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_DEPROP_1_Reason: Reason
            }
        case TOWER_DEPROP_2:
            return {
                TOWER_DEPROP_2,
                TOWER_DEPROP_2_HoursOffline: HoursOffline,
                TOWER_DEPROP_2_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_DEPROP_2_Reason: Reason
            }
        case TOWER_DEPROP_3:
            return {
                TOWER_DEPROP_3,
                TOWER_DEPROP_3_HoursOffline: HoursOffline,
                TOWER_DEPROP_3_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_DEPROP_3_Reason: Reason
            }
        case TOWER_DEPROP_4:
            return {
                TOWER_DEPROP_4,
                TOWER_DEPROP_4_HoursOffline: HoursOffline,
                TOWER_DEPROP_4_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_DEPROP_4_Reason: Reason
            }
        case TOWER_DEBUT_1:
            return {
                TOWER_DEBUT_1,
                TOWER_DEBUT_1_HoursOffline: HoursOffline,
                TOWER_DEBUT_1_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_DEBUT_1_Reason: Reason
            }
        case TOWER_DEBUT_3:
            return {
                TOWER_DEBUT_3,
                TOWER_DEBUT_3_HoursOffline: HoursOffline,
                TOWER_DEBUT_3_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_DEBUT_3_Reason: Reason
            }
        case TOWER_DEBUT_4:
            return {
                TOWER_DEBUT_4,
                TOWER_DEBUT_4_HoursOffline: HoursOffline,
                TOWER_DEBUT_4_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_DEBUT_4_Reason: Reason
            }
        case TOWER_SPLITTER_1:
            return {
                TOWER_SPLITTER_1,
                TOWER_SPLITTER_1_HoursOffline: data.HoursOffline,
                TOWER_SPLITTER_1_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_SPLITTER_1_Reason: Reason
            }
        case TOWER_SPLITTER_3:
            return {
                TOWER_SPLITTER_3,
                TOWER_SPLITTER_3_HoursOffline: data.HoursOffline,
                TOWER_SPLITTER_3_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_SPLITTER_3_Reason: Reason
            }
        case TOWER_SPLITTER_4:
            return {
                TOWER_SPLITTER_4,
                TOWER_SPLITTER_4_HoursOffline: data.HoursOffline,
                TOWER_SPLITTER_4_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_SPLITTER_4_Reason: data.Reason
            }
        case TOWER_SPLITTER_6:
            return {
                TOWER_SPLITTER_6,
                TOWER_SPLITTER_6_HoursOffline: data.HoursOffline,
                TOWER_SPLITTER_6_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_SPLITTER_6_Reason: data.Reason
            }
        case TOWER_UPGRADER:
            return {
                TOWER_UPGRADER,
                TOWER_UPGRADER_HoursOffline: data.HoursOffline,
                TOWER_UPGRADER_ADJHRSOFFLINE: AdjustedHoursOffline,
                TOWER_UPGRADER_Reason: data.Reason
            }
        default:
            return
    }
}

export const getCustomizedRowData = (data, daysInMonth) => {
    const finalData = []
    if (data.length) {
        daysInMonth.forEach(date => {
            let id = null
            let towersInfo = {}
            let updatedBy = null
            let updatedOn = null
            const rowDataWithDate = data.filter(item => item.Date === date)
            rowDataWithDate.forEach(rowData => {
                // skip if data for this date is unavailable
                if (rowData?.ID) {
                    id = id ? `${id}_${rowData.ID}` : `${rowData.ID}`
                    if (rowData?.UpdatedBy)
                        updatedBy = rowData?.UpdatedBy
                    if (rowData?.UpdatedOn)
                        updatedOn = rowData?.UpdatedOn
                    towersInfo = { ...towersInfo, ...getTowerDetails(rowData.Tower, rowData) }
                }
            })
            // skip if data for this date is unavailable
            if (id) {
                finalData.push({
                    ID: id,
                    Date: date,
                    UpdatedBy: updatedBy,
                    UpdatedOn: updatedOn,
                    ...towersInfo,
                })
            }
        });
    }
    return finalData
}

export const paintColumnInGrey = (params) => {
    return { backgroundColor: 'rgba(225, 225, 234, 1)' }
}

export const gridCellClassRulesEditable = {
    'grid-cell-editable': (params) => { return params.data ? true : false }
}

export const gridCellClassRulesNonEditable = {
    'grid-cell-non-editable': params => { return params.data ? true : false }
}